<script setup lang="ts">
import { getCSSVariable } from '@/helpers/utils'

interface Props {
  color: string
}

withDefaults(defineProps<Props>(), {
  color: getCSSVariable('ui-emerald-green'),
})
</script>

<template>
  <svg
    class="icon"
    width="25"
    height="25"
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Vector">
      <path
        d="M9 16.7149L4.83 12.5449L3.41 13.9549L9 19.5449L21 7.54492L19.59 6.13492L9 16.7149Z"
        :fill="color"
      />
    </g>
  </svg>
</template>

<style lang="scss" scoped>
.icon {
  min-width: 25px;
}
</style>
